// import React from "react";
// import { WebView } from "react-native-webview";
// import { useNavigation } from "@react-navigation/native";

// const PaymentWebView = ({ route }) => {
//   const navigation = useNavigation();
//   const { paymentUrl } = route.params;

//   const handleMessage = (event) => {
//     const data = event.nativeEvent.data;
//     console.log("WebView Message:", data);

//     if (data === "payment_success") {
//       console.log("payment sucess:");
//       // navigation.navigate('GenderPage');
//       setTimeout(() => {
//         // navigation.navigate('GenderPage');
//         navigation.reset({
//           index: 0,
//           routes: [{ name: "GenderPage" }],
//         });
//       }, 2000);
//     } else {
//       // navigation.navigate('PaymentScreen');
//       setTimeout(() => {
//         navigation.navigate("PaymentScreen");
//       }, 2000);
//     }
//   };

//   return (
//     <WebView
//       source={{ uri: paymentUrl }}
//       onMessage={handleMessage}
//       javaScriptEnabled={true}
//       domStorageEnabled={true}
//     />
//   );
// };

// export default PaymentWebView;

// import React, { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const PaymentWebView = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const { paymentUrl } = location.state || {};

//   useEffect(() => {
//     const handleMessage = (event) => {
//       const data = event.data;

//       // Optional: Validate origin for security
//       // if (event.origin !== "https://connecttovow.com") return;

//       if (data === 'payment_success') {
//         setTimeout(() => {
//           navigate('/gender', { replace: true });
//         }, 2000);
//       } else {
//         setTimeout(() => {
//           navigate('/payment');
//         }, 2000);
//       }
//     };

//     window.addEventListener('message', handleMessage);

//     return () => {
//       window.removeEventListener('message', handleMessage);
//     };
//   }, [navigate]);

//   if (!paymentUrl) {
//     return <p>Payment URL not found.</p>;
//   }

//   return (
//     <div style={{ height: '100vh' }}>
//       <iframe
//         src={paymentUrl}
//         title="Payment"
//         style={{ width: '100%', height: '100%', border: 'none' }}
//         allowFullScreen
//       />
//     </div>
//   );
// };

// export default PaymentWebView;

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentWebView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { paymentUrl } = location.state || {};

  useEffect(() => {
    const handleMessage = (event) => {
      const data = event.data;

      console.log("Message from payment iframe:", data);

      if (data === "payment_success") {
        console.log("Payment successful");
        setTimeout(() => {
          navigate("/gender", { replace: true });
        }, 1000);
      } else {
        console.log("Payment failed or other message");
        setTimeout(() => {
          navigate("/PaymentScreen", { replace: true });
        }, 1000);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  if (!paymentUrl) {
    return <p>Payment URL not found.</p>;
  }

  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src={paymentUrl}
        title="Payment"
        style={{ width: "100%", height: "100%", border: "none" }}
        allow="payment"
      />
    </div>
  );
};

export default PaymentWebView;
